<script setup lang="ts">

import {computed} from "vue";

const props = defineProps({
  width: {
    type: String,
    default: '100%'
  },
  height: {
    type: String,
    default: '1.4em'
  }
})

const width = computed(() => {
  return props.width;
})

const height = computed(() => {
  return props.height;
})

const divStyle = computed(() => {
  return {
    width: width.value,
    height: height.value
  }
})
</script>

<template>
<div class="cap-skeleton" :style="divStyle" :width="width" :height="height"></div>
</template>

<style scoped lang="less">
.cap-skeleton {
  background-color: #dee2e6;
  border-radius: 6px;
  overflow: hidden;
  box-sizing: border-box;
  position: relative;
  &::after {
    content: '';
    animation: p-skeleton-animation 1.2s infinite;
    height: 100%;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    transform: translateX(-100%);
    z-index: 1;
  }
  &::after {
    background: linear-gradient(90deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.4), rgba(255, 255, 255, 0));
  }

  @keyframes p-skeleton-animation {
    from {
      transform: translateX(-100%);
    }
    to {
      transform: translateX(100%);
    }
  }
}
</style>
